<script>
    import cross from "$lib/images/cross.svg"

    export let modalData;
    export let closeModal;
</script>

<div class="modal-container">
    <div style="width: 100%; display: flex; justify-content: space-between; align-items: flex-start;">
        <h2>{modalData.title}</h2>
        <button on:click={closeModal}>
            <img src="{cross}" alt="Cross">
        </button>
    </div>
    <p>{@html modalData.description}</p>
</div>

<style lang="scss">
    @import "/src/lib/scss/main";
    @import "/src/lib/scss/responsible";

    @media screen and (max-width: 700px) {

        .modal-container {
            width: 385px !important;
            gap: 30px!important;
        }

        h2 {
            max-width: 250px !important;
            font-size: 25px !important;
        }

        img {
            width: 18px !important;
            height: 19px !important;
        }

        p {
            max-height: none !important;
            height: 500px !important;
            font-size: 15px !important;
        }
    }

    .modal-container {
        display: flex;
        flex-direction: column;
        @include fluid("gap", 30);
        font-family: "Gotham Pro", sans-serif;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        @include fluid("width", 980);
        height: auto;
        @include fluid("padding-top", 50);
        @include fluid("padding-bottom", 50);
        @include fluid("padding-left", 100);
        @include fluid("padding-right", 100);
        @include fluid("border", 1, "solid rgba(255, 255, 255, 0.3)");
        @include fluid("border-radius", 20);
        background: #0F0F0F;
    }

    h2 {
        font-weight: 900;
        font-style: italic;
        @include fluid("font-size", 36);
        line-height: 110%;
        color: #FFFFFF;
        @include fluid("max-width", 680);
    }

    button {
        cursor: pointer;
        background: transparent;
        border: none;

        &:hover {

            img {
                content: url("/src/lib/images/cross_hover.svg");
            }
        }
    }

    img {
        margin-top: 5px;
        @include fluid("width", 18);
        @include fluid("height", 19);
        transition: 0.2s;
    }

    p {
        @include fluid("max-height", 505);
        overflow-y: auto;
        font-weight: normal;
        font-style: normal;
        @include fluid("font-size", 16);
        line-height: 134%;
        color: rgba(255, 255, 255, 0.6);
        padding-right: 20px;
    }
</style>